import React, { FC } from 'react';
import { useAppDispatch, useAppSelector } from 'common/hooks';
import { VoiceCall, VoiceCallActive } from 'entities/Calls/components';
import { getEventAvailableOperations } from 'entities/Events/Event.helper';
import { IEvent } from 'entities/Events/Event.models';

interface IComponentProps {
  event: IEvent | null;
}

export const VoiceCallWrapper: FC<IComponentProps> = ({ event }) => {
  const { auth, timerIsRunning, twilioToken, twilioOnCall, twilioDuration, twilioLoading } = useAppSelector((state) => ({
    auth: state.auth.data,
    timerIsRunning: state.timer.isRunning,
    twilioToken: state.twilio.token,
    twilioOnCall: state.twilio.onCall,
    twilioDuration: state.twilio.duration,
    twilioLoading: state.twilio.loading,
  }));
  const { timer: timerDispatch, twilio: twilioDispatch } = useAppDispatch();

  const currentUserId = auth?.access?.id;
  const role = auth?.access?.rights[0];
  const phone = event?.phone;
  const { canStart } = getEventAvailableOperations({
    status: event?.status,
    type: event?.type,
    role,
    currentUserId,
    staffId: event?.staffId,
    physicianId: event?.physicianId,
  });

  const onCallClick = () => {
    if (event) {
      if (canStart && !timerIsRunning) {
        timerDispatch.startTimer({
          eventId: event.id,
          onSuccess: () => twilioDispatch.getVoiceCallToken(),
        });
      } else {
        twilioDispatch.getVoiceCallToken();
      }
    }
  };

  const onEndCallClick = () => {
    if (event) {
      if (twilioOnCall && twilioDuration) {
        twilioDispatch.trackVoiceCallDuration({ eventId: event.id, duration: twilioDuration });
      }

      twilioDispatch.resetTwilioState();
    }
  };

  return twilioToken ? (
    <VoiceCallActive
      token={twilioToken}
      phone={phone}
      onCall={twilioOnCall}
      setOnCall={twilioDispatch.setOnCall}
      setDuration={twilioDispatch.setDuration}
      onEndCallClick={onEndCallClick}
    />
  ) : (
    <VoiceCall phone={phone} loading={twilioLoading} onCall={twilioOnCall} onCallClick={onCallClick} />
  );
};
